module.exports = __webpack_public_path__ + "static/media/boy_on_horse.96a66927.gif";